/* Kudeko Espacios F1.1: launcher temprano; minis asincrónicas, visor solo bajo demanda. */
(() => {
  'use strict';
  if (window.KdkSpaces) { window.KdkSpaces.mount?.(); return; }
  const cfg = window.KDK_SPACES_CONFIG;
  if (!cfg || cfg.enabled === false) return;
  const early = window.KdkSpacesEarly;
  const key = cfg.storageNamespace + ':index';
  let pending, storePending, guidedPending, thumbnailSequence = 0;
  const thumbnailUrls = new Map();
  function readIndex() { return early?.read() || []; }
  function loadScript(url) {
    return new Promise((resolve, reject) => {
      const el = document.createElement('script'); el.src = url; el.async = true;
      el.onload = resolve; el.onerror = () => { el.remove(); reject(new Error('load_failed')); };
      document.head.appendChild(el);
    });
  }
  function ensureStore() {
    if (window.KdkSpacesStore) return Promise.resolve(window.KdkSpacesStore);
    if (!storePending) storePending = loadScript(cfg.storeUrl).then(() => window.KdkSpacesStore).catch(e => { storePending = null; throw e; });
    return storePending;
  }
  function loadCss() {
    if (document.getElementById('kdk-spaces-css')) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const el = document.createElement('link'); el.id = 'kdk-spaces-css'; el.rel = 'stylesheet'; el.href = cfg.cssUrl;
      el.onload = resolve; el.onerror = () => { el.remove(); reject(new Error('load_failed')); };
      document.head.appendChild(el);
    });
  }
  function ensure() {
    if (pending) return pending;
    pending = Promise.all([
      loadCss(), ensureStore(),
      fetch(cfg.i18nUrl, { credentials: 'omit' }).then(r => { if (!r.ok) throw new Error('load_failed'); return r.json(); }).then(strings => { window.KDK_SPACES_I18N = strings; })
    ]).then(() => window.KdkSpacesUI ? null : loadScript(cfg.runtimeUrl))
      .then(() => { if (!window.KdkSpacesUI) throw new Error('load_failed'); return window.KdkSpacesUI; })
      .catch(error => { pending = null; throw error; });
    return pending;
  }
  function ensureGuided() {
    if (guidedPending) return guidedPending;
    guidedPending = ensure().then(async () => {
      if (!document.getElementById('kdk-spaces-guided-css')) {
        await new Promise((resolve,reject) => { const l = document.createElement('link'); l.id='kdk-spaces-guided-css'; l.rel='stylesheet'; l.href=cfg.guidedCssUrl; l.onload=resolve; l.onerror=()=>{l.remove();reject(new Error('load_failed'));}; document.head.appendChild(l); });
      }
      if (!window.KdkSpacesGeometry) await loadScript(cfg.guidedGeometryUrl);
      if (!window.KdkSpacesProducts) await loadScript(cfg.guidedProductsUrl);
      if (!window.KdkSpacesGuided) await loadScript(cfg.guidedUrl);
      return window.KdkSpacesGuided;
    }).catch(e=>{guidedPending=null;throw e;});
    return guidedPending;
  }
  function mount(scope = document, rows) { early?.mount(scope, rows); }
  async function hydrateThumbnails(providedRows) {
    const seq = ++thumbnailSequence;
    const store = await ensureStore();
    const rows = providedRows || await store.list();
    if (seq !== thumbnailSequence) return;
    const live = new Set(rows.map(r => r.id + ':' + r.revision));
    for (const [k, url] of thumbnailUrls) if (!live.has(k)) { URL.revokeObjectURL(url); thumbnailUrls.delete(k); }
    // No se sustituye el botón cuando llegan las minis; rellenar los espacios reservados.
    const top = rows.slice(0,3);
    await Promise.all(top.map(async row => {
      const k = row.id + ':' + row.revision;
      if (!thumbnailUrls.has(k)) {
        try {
          const blob = await store.image(row.id, 'thumb');
          if (seq !== thumbnailSequence) return;
          thumbnailUrls.set(k, URL.createObjectURL(blob));
        } catch (_) { return; }
      }
      if (seq !== thumbnailSequence) return;
      document.querySelectorAll('[data-ksp-thumb-id]').forEach(tile => {
        if (tile.dataset.kspThumbId !== row.id) return;
        let image = tile.querySelector('img');
        if (!image) { image = document.createElement('img'); image.alt = ''; image.width = 25; image.height = 24; image.decoding = 'async'; tile.appendChild(image); }
        const src = thumbnailUrls.get(k); if (image.getAttribute('src') !== src) image.src = src;
      });
    }));
  }
  function loadError(button) {
    if (!button) return;
    button.removeAttribute('aria-busy'); button.title = cfg.loadError;
    document.querySelector('.ksp-load-error')?.remove();
    const message = document.createElement('div'); message.className = 'ksp-load-error'; message.setAttribute('role','status'); message.textContent = cfg.loadError; document.body.appendChild(message);
    setTimeout(() => message.remove(), 6000);
  }
  function launch(button) {
    button.setAttribute('aria-busy','true'); document.querySelector('.ksp-load-error')?.remove();
    ensure().then(ui => { button.removeAttribute('aria-busy'); return ui.launch(button); }).catch(() => loadError(button));
  }
  let cartPending;
  function ensureCart() {
    if (!cartPending) cartPending = ensure().then(async () => {
      if (!window.KdkSpacesGeometry) await loadScript(cfg.guidedGeometryUrl);
      if (!window.KdkSpacesProducts) await loadScript(cfg.guidedProductsUrl);
      if (!document.getElementById('kdk-spaces-cart-css')) await new Promise((resolve,reject) => {
        const l=document.createElement('link');l.id='kdk-spaces-cart-css';l.rel='stylesheet';l.href=cfg.cartCssUrl;
        l.onload=resolve;l.onerror=()=>{l.remove();reject(Error('load_failed'));};document.head.appendChild(l);
      });
      if (!window.KdkCartPreview) await loadScript(cfg.cartRuntimeUrl);
      return window.KdkCartPreview;
    }).catch(e=>{cartPending=null;throw e;});
    return cartPending;
  }
  document.addEventListener('click', event => {
    const button=event.target.closest?.('[data-kdk-cart-preview]');if(!button)return;
    event.preventDefault();if(button.disabled)return;window.KdkPreviewAnalytics?.cartStart();button.disabled=true;button.setAttribute('aria-busy','true');
    ensureCart().then(app=>app.open(button)).catch(()=>loadError(button)).finally(()=>{button.disabled=false;button.removeAttribute('aria-busy');});
  });
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-kdk-spaces-button]'); if (!button) return;
    event.preventDefault(); launch(button);
  });
  window.KdkSpaces = {
    ensure, ensureGuided, ensureCart, mount, hydrateThumbnails,
    attach(instance) { return ensure().then(ui => { ui.attach(instance); if(cfg.guidedEnabled && instance.mode === 'ai') return ensureGuided().then(g => g.attach(instance)); }).catch(() => { if (instance.aiStatusEl && !instance.aiProcessing) instance._setStatus(instance.aiStatusEl, cfg.loadError, 'error'); }); },
    refresh(instance) { window.KdkSpacesUI?.refresh(instance); },
    open() { return ensure().then(ui => ui.openLibrary()); }
  };
  function recover() {
    mount();
    if (readIndex().length) hydrateThumbnails().catch(() => {});
    // No se carga CSS, diccionario ni visor por el solo hecho de tener espacios.
  }
  function start() {
    const pendingId = new URLSearchParams(location.search).get('kdk_edit_space');
    if (pendingId && /^[a-zA-Z0-9-]{8,80}$/.test(pendingId)) {
      let tries = 0;
      const resume = () => {
        const shell = document.querySelector('[data-kdk-preview-shell]');
        const root = document.querySelector('.kdk-pdp-preview');
        if (shell && window.KDKPdpPreviewLoader) { window.KDKPdpPreviewLoader.openPreview(shell); return; }
        if (root?.__kdkProductPreviewer) { root.__kdkProductPreviewer.open(); return; }
        if (++tries < 25) setTimeout(resume, 200);
      };
      resume();
    }
    recover();
    document.querySelectorAll('[data-ksp-pending-click]').forEach(b => { delete b.dataset.kspPendingClick; launch(b); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', recover);
  window.addEventListener('pageshow', event => { if (event.persisted) recover(); });
  window.addEventListener('storage', event => { if (event.key === key) recover(); });
  document.addEventListener('kdk:spaces:changed', event => {
    const rows = event.detail?.rows;
    mount(document, rows);
    hydrateThumbnails(rows).catch(() => {});
  });
})();
